export const POST_TINH_TRANG_NO = "POST_TINH_TRANG_NO";
export const POST_TINH_TRANG_NO_SUCCESS = "POST_TINH_TRANG_NO_SUCCESS";
export const POST_TINH_TRANG_NO_FAILURE = "POST_TINH_TRANG_NO_FAILURE";
